import type { GroupAnalysisResponse } from '../../api/types.js';

export function canStartAnalysis(analysis: GroupAnalysisResponse): boolean {
  return analysis.eligibility === 'eligible'
    && analysis.latestRun?.status !== 'running'
    && analysis.latestMessageId !== null
    && analysis.latestMessageId > (analysis.snapshot?.analyzedThroughMessageId ?? 0);
}

export function shouldStartOnEntry(analysis: GroupAnalysisResponse): boolean {
  return analysis.latestRun?.status !== 'failed' && canStartAnalysis(analysis);
}

export const ANALYSIS_INELIGIBLE_LABELS = {
  unmapped_bot: '该工作号尚未配置智能分析',
  designer_group: '设计师群不在客户群分析范围内',
  name_excluded: '该群不在当前商家的客户群分析范围内',
  no_messages: '该群暂无可分析的入站消息',
} as const;
